import store from '@/store'

export default {

  GetItems: function () {

    var items = [
      {
        name: 'Single Term Scan',
        url: '/RunScan',
        icon: 'fa fa-arrow-circle-left',
        sortOrder: 12,
        roles: ['User', 'Admin']
      },
      {
        name: 'mPencil Scan',
        url: '/APIDemo',
        icon: 'fa fa-pencil',
        sortOrder: 16,
        roles: ['User', 'Admin']
      },
      {
        name: 'DMV Fees',
        url: '/DMVFees',
        icon: 'fa fa-car',
        sortOrder: 20,
        roles: ['User', 'Admin']
      }
    ];

    items.sort(function (a, b) { return a.sortOrder - b.sortOrder });

    items = items.filter(function (item) {
      if (item.roles === undefined) {
        return true;
      } else {
        var currentRole = store.state.currentRole;
        return item.roles.indexOf(currentRole) !== -1;
      }
    });

    return items;
  },
}



// WEBPACK FOOTER //
// ./src/_nav.js